import React, {useEffect} from "react"
import Loader from "../../components/loader/Loader"
import {useGetPermissionsQuery} from "./permissionApi"
import {Route, Routes} from "react-router-dom"

const loadApplications = () => import("pages/applications")
const loadClients = () => import("pages/clients")
const loadCities = () => import("pages/cities")
const loadBranches = () => import("pages/branches")
const loadBasicMenu = () => import("pages/basic-menu")
const loadNotFound = () => import("pages/not-found")

const pageLoaders = [loadApplications, loadClients, loadCities, loadBranches, loadBasicMenu, loadNotFound]

const Applications = React.lazy(loadApplications)
const Clients = React.lazy(loadClients)
const Cities = React.lazy(loadCities)
const Branches = React.lazy(loadBranches)
const BasicMenu = React.lazy(loadBasicMenu)
const NotFound = React.lazy(loadNotFound)

const PermissionRoutes: React.FC = () => {
    const {isLoading, data, isSuccess} = useGetPermissionsQuery()

    // Чанки страниц грузятся параллельно с запросом прав. Без этого получается водопад:
    // сначала лоадер прав, сразу за ним — лоадер Suspense.
    useEffect(() => {
        pageLoaders.forEach(load => load())
    }, [])

    // Один лоадер на всю загрузку приложения: и на права, и на чанк страницы
    return (
        <React.Suspense fallback={<Loader>Загрузка...</Loader>}>
            {isLoading ? (
                <Loader>Загрузка...</Loader>
            ) : (
                <Routes>
                    {isSuccess ? (
                        <>
                            <Route index element={<Applications />} />
                            // TODO: Implement permissions correctly; the backend currently only supports 'can_use_system'.
                            {<Route path="/clients" element={<Clients />} />}
                            {/*{data?.is_clients_read ? <Route path="/clients" element={<Clients />} /> : null}*/}
                            <Route path="/menu" element={<BasicMenu />} />
                            <Route path="/cities" element={<Cities />} />
                            <Route path="/branches" element={<Branches />} />
                            <Route path="*" element={<NotFound />} />
                        </>
                    ) : (
                        <Route path="*" element={<NotFound />} />
                    )}
                </Routes>
            )}
        </React.Suspense>
    )
}

export default PermissionRoutes
